module.exports = __webpack_public_path__ + "media/images/return-ff19e1737c8f81e34a74b849c3a298d1.svg";